<span class="cell--active" *ngIf="showActiveApp" uiTooltip="Active app for processing in web UI"
  uiTooltipPosition="bottom">
  <span>Active in Web UI</span>
</span>
<span class="sort cell--name">
  Name
</span>
